<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('drawer_title_goods_review') || '产品信息审核'"
      :visible="visible"
      direction="rtl"
      :size="1200"
      show-close
      @close="close"
      append-to-body
    >
      <div>
        <div class="p-2">
          <div class="text-right">
            <el-button size="small" @click="close()">
              {{ $l('btn_review_close') || '关闭' }}
            </el-button>
            <el-button type="success" size="small" @click="approved()">
              {{ $l('btn_review_pass') || '通过' }}
            </el-button>
            <el-button type="danger" size="small" @click="reject()">
              {{ $l('btn_review_reject') || '驳回' }}
            </el-button>
          </div>
        </div>

        <GoodsInfo disabled :evgSkuCode="evgSkuCode" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import GoodsInfo from '@/views/ecom/base/evgGoods/components/evg-good-info'
export default {
  mixins: [EditLoading],
  components: { GoodsInfo },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    evgSkuCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
    }
  },
  computed: {
    title() {
      return this.titleMap[this.type]
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    async approved() {
      const confirm = await this.$confirm(
        this.$l('evg_goods_information_approved_content') ||
          '是否要通过该SKU信息审核申请？',
        this.$l('evg_goods_information_approved_title') || '确认信息',
        {
          confirmButtonText:
            this.$l('btn_information_approved_confirm') || '确定',
          cancelButtonText:
            this.$l('btn_information_approved_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const listEvgSkuCode = [this.evgSkuCode]
      const res = await this.$api
        .ecomEvgSkuInformationApprovedApi({ listEvgSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('message_information_approved_pass_failed') || '通过失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message:
          this.$l('message_information_approved_pass_success') || '通过成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    reject() {
      this.$prompt(
        this.$l('tips_information_review') || '是否要审核驳回？',
        this.$l('tips_information_review_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_review_confirm') || '确定',
          cancelButtonText: this.$l('btn_review_cancel') || '取消',
          inputPlaceholder:
            this.$l('placeholder_review_input') || '请输入驳回原因',
          inputType: 'textarea',
          inputValidator: (value) => {
            if (value) {
              return true
            }
            return this.$l('validator_review_input') || '请输入驳回原因'
          },
          inputErrorMessage:
            this.$l('error_message_review_input') || '请输入驳回原因',
        }
      )
        .then(({ value }) => {
          if (this.loadingOpen()) return
          this.$api
            .ecomEvgSkuInformationRejectApi({
              listEvgSkuCode: [this.evgSkuCode],
              rejectReason: value,
            })
            .then((res) => {
              this.loadingClose()
              const { status } = res
              if (status == 200) {
                this.$message({
                  showClose: true,
                  message: this.$l('tips_review_success') || '驳回成功',
                  type: 'success',
                })
              }
              this.$emit('reload')
              this.close()
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 10px 12px;
}

::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
